import React, { FC } from 'react'
import { breakpoint, styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import {
  AddToBasketCTAModule,
  BreadcrumbsModule,
  ColumnModule,
  DispatchCutOffBannerModule,
  GiftImageCarouselModule,
  KlarnaInfoModule,
  ListModule,
  OfferBannerModule,
  PriceModule,
  ProductPillsModule,
  ProductSellingPointsModule,
  ProductTitleModule,
  RatingModule,
  VariantSelectorModule,
} from '../../modules'

const StyledAddToBasketCTAModule = styled(AddToBasketCTAModule)`
  ${breakpoint('md')} {
    position: sticky;
    top: 0;
    z-index: 1;
    padding-top: ${spacingPx(10)};
    box-shadow: -4px 0 0 0 #fff, 4px 0 0 0 #fff;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 80%,
      rgba(255, 255, 255, 0.1)
    );
  }
  ${breakpoint('xl')} {
    top: 132px;
  }
`

export const DigitalGiftTop: FC = () => {
  return (
    <div data-testid="mp-find-digital-gift-details">
      <OfferBannerModule width={1} />
      <BreadcrumbsModule withContainer />
      <ColumnModule py={{ xs: 0, md: 6 }}>
        <GiftImageCarouselModule
          flex={{ xs: 'inherit', md: 1 }}
          width={1}
          px={{ xs: 8, md: 0 }}
        />
        <ListModule>
          <ProductTitleModule px={{ xs: 8, md: 0 }} width={1} />
          <RatingModule px={{ xs: 8, md: 0 }} width={1} />
          <PriceModule px={{ xs: 8, md: 0 }} width={1} />
          <VariantSelectorModule px={{ xs: 8, md: 0 }} width={1} />
          <ProductPillsModule px={{ xs: 8, md: 0 }} width={1} />
          <KlarnaInfoModule px={{ xs: 8, md: 0 }} width={1} />
          <DispatchCutOffBannerModule
            width={1}
            borderRadius={{ xs: 0, md: 2 }}
          />
          <ProductSellingPointsModule borderRadius={{ xs: 0, md: 1 }} />
          <StyledAddToBasketCTAModule width={1} px={{ xs: 8, md: 0 }} />
        </ListModule>
      </ColumnModule>
    </div>
  )
}
